/**
 * Sentry Error Monitoring for Afikim Frontend
 * Feature flag: REACT_APP_SENTRY_DSN (empty = disabled, all functions become no-ops)
 */

const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN || '';
const SENTRY_ENVIRONMENT = process.env.REACT_APP_SENTRY_ENVIRONMENT ||
  (window.location.hostname === 'localhost' ? 'development' : 'production');

export const SENTRY_ENABLED = !!SENTRY_DSN;

let Sentry = null;

export async function initSentry() {
  if (!SENTRY_DSN) {
    console.log('[Sentry] Disabled (REACT_APP_SENTRY_DSN not set)');
    return;
  }

  try {
    Sentry = await import('@sentry/react');

    Sentry.init({
      dsn: SENTRY_DSN,
      tunnel: '/api/sentry-tunnel',
      environment: SENTRY_ENVIRONMENT,
      release: `afikim-frontend@${process.env.REACT_APP_VERSION || '1.0.0'}`,
      tracesSampleRate: 0.1,

      beforeSend(event) {
        // Filter out ChunkLoadError (handled by service worker cleanup)
        if (event.exception?.values?.some(e => e.type === 'ChunkLoadError')) {
          return null;
        }
        return event;
      },

      ignoreErrors: [
        'ResizeObserver loop',
        'Loading chunk',
        'Failed to fetch',
        'Network request failed',
        'AbortError',
      ],
    });

    console.log(`[Sentry] Initialized | env=${SENTRY_ENVIRONMENT}`);
  } catch (err) {
    console.warn('[Sentry] Failed to initialize:', err.message);
  }
}

export function setSentryUser(user) {
  if (!Sentry || !user) return;
  try {
    Sentry.setUser({
      email: user.email || user.username,
      username: user.username || user.email,
    });
  } catch (e) { /* ignore */ }
}

export function clearSentryUser() {
  if (!Sentry) return;
  try {
    Sentry.setUser(null);
  } catch (e) { /* ignore */ }
}

export function captureError(error, context = {}) {
  if (!Sentry) return;
  try {
    Sentry.captureException(error, { extra: context });
  } catch (e) { /* ignore */ }
}

export function getSentry() {
  return Sentry;
}
